export var FileResourceType;

(function (FileResourceType) {
  FileResourceType[FileResourceType["Image"] = 1] = "Image";
  FileResourceType[FileResourceType["Audio"] = 2] = "Audio";
  FileResourceType[FileResourceType["Video"] = 3] = "Video";
  FileResourceType[FileResourceType["Document"] = 4] = "Document";
  FileResourceType[FileResourceType["Other"] = 5] = "Other";
})(FileResourceType || (FileResourceType = {}));